import { Navigate, Route, Routes } from 'react-router-dom';
import { usePermission } from '@backstage/plugin-permission-react';
import { pulseTrackCreatePermission } from '@internal/backstage-plugin-pulse-common';
import {
  tracksDetailsSubRouteRef,
  tracksEditSubRouteRef,
  tracksNewSubRouteRef,
} from '../../routes';
import { PulseTracksPage } from './tracks-page';
import { PulseTracksDetails } from './tracks-details';
import { PulseTrackFormPage } from './create-track';

const PulseTrackCreateRoute = () => {
  const { allowed, loading } = usePermission({
    permission: pulseTrackCreatePermission,
  });

  if (loading) {
    return null;
  }

  return allowed ? <PulseTrackFormPage /> : <Navigate to="/" replace />;
};

export const PulseTracksRouting = () => {
  return (
    <Routes>
      <Route path="/" element={<PulseTracksPage />} />
      <Route
        path={tracksNewSubRouteRef.path}
        element={<PulseTrackCreateRoute />}
      />
      <Route
        path={tracksEditSubRouteRef.path}
        element={<PulseTrackFormPage />}
      />
      <Route
        path={tracksDetailsSubRouteRef.path}
        element={<PulseTracksDetails />}
      />
      <Route path="*" element={<PulseTracksPage />} />
    </Routes>
  );
};
